var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rights-exchange-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "按钮文本：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入按钮文本" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.buttonText,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "buttonText", $$v)
                  },
                  expression: "itemInfo.buttonText",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "文字位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.textPosition,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "textPosition", $$v)
                    },
                    expression: "itemInfo.textPosition",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("居左")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("居中")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("居右")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "主题颜色：" } }, [
            _c(
              "div",
              { staticClass: "flex-between" },
              [
                _c("el-color-picker", {
                  attrs: { "show-alpha": "" },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.themeColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "themeColor", $$v)
                    },
                    expression: "itemInfo.themeColor",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "80%" },
                  on: { input: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.themeColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "themeColor", $$v)
                    },
                    expression: "itemInfo.themeColor",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "按钮宽度：" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("el-button", {
                  attrs: {
                    type: "default",
                    icon: "el-icon-minus",
                    size: "mini",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.decreaseValue("buttonWidth")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "80px",
                      margin: "0 10px",
                      "text-align": "center",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { size: "mini", type: "number" },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.buttonWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "buttonWidth", _vm._n($$v))
                        },
                        expression: "itemInfo.buttonWidth",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-button", {
                  attrs: {
                    type: "default",
                    icon: "el-icon-plus",
                    size: "mini",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.increaseValue("buttonWidth")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "按钮高度：" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("el-button", {
                  attrs: {
                    type: "default",
                    icon: "el-icon-minus",
                    size: "mini",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.decreaseValue("buttonHeight")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "80px",
                      margin: "0 10px",
                      "text-align": "center",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { size: "mini", type: "number" },
                      on: { change: _vm.updateItem },
                      model: {
                        value: _vm.itemInfo.buttonHeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemInfo, "buttonHeight", _vm._n($$v))
                        },
                        expression: "itemInfo.buttonHeight",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-button", {
                  attrs: {
                    type: "default",
                    icon: "el-icon-plus",
                    size: "mini",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.increaseValue("buttonHeight")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "按钮圆角：" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.cornerType,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "cornerType", $$v)
                      },
                      expression: "itemInfo.cornerType",
                    },
                  },
                  [_vm._v("统一设置")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-left": "20px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "default",
                        icon: "el-icon-minus",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.decreaseValue("borderRadius")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "80px",
                          margin: "0 10px",
                          "text-align": "center",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { size: "mini", type: "number" },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.borderRadius,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.itemInfo,
                                "borderRadius",
                                _vm._n($$v)
                              )
                            },
                            expression: "itemInfo.borderRadius",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: {
                        type: "default",
                        icon: "el-icon-plus",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.increaseValue("borderRadius")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 2 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.cornerType,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "cornerType", $$v)
                      },
                      expression: "itemInfo.cornerType",
                    },
                  },
                  [_vm._v("分开设置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.itemInfo.cornerType === 2
              ? _c("div", { staticClass: "separate-settings" }, [
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("左上角")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("borderRadiusTopLeft")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.borderRadiusTopLeft,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "borderRadiusTopLeft",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.borderRadiusTopLeft",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("borderRadiusTopLeft")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("右上角")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("borderRadiusTopRight")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.borderRadiusTopRight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "borderRadiusTopRight",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.borderRadiusTopRight",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("borderRadiusTopRight")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("右下角")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue(
                                "borderRadiusBottomRight"
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.borderRadiusBottomRight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "borderRadiusBottomRight",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.borderRadiusBottomRight",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue(
                                "borderRadiusBottomRight"
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("左下角")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("borderRadiusBottomLeft")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.borderRadiusBottomLeft,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "borderRadiusBottomLeft",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.borderRadiusBottomLeft",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("borderRadiusBottomLeft")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "按钮背景：" } }, [
            _c(
              "div",
              {
                staticClass: "upLoadPicBox",
                on: {
                  click: function ($event) {
                    return _vm.modalPicTap("1", "bgImg")
                  },
                },
              },
              [
                _vm.itemInfo.bgImg
                  ? _c("div", { staticClass: "pictrue" }, [
                      _c("img", {
                        attrs: { src: _vm.itemInfo.bgImg, alt: "" },
                      }),
                    ])
                  : _c("div", { staticClass: "upLoad" }, [
                      _c("i", { staticClass: "el-icon-plus" }),
                    ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _c(
              "div",
              {
                staticClass: "upLoadPicBox",
                on: {
                  click: function ($event) {
                    return _vm.modalPicTap("1", "bgPic")
                  },
                },
              },
              [
                _vm.itemInfo.bgPic
                  ? _c("div", { staticClass: "pictrue" }, [
                      _c("img", {
                        attrs: { src: _vm.itemInfo.bgPic, alt: "" },
                      }),
                    ])
                  : _c("div", { staticClass: "upLoad" }, [
                      _c("i", { staticClass: "el-icon-plus" }),
                    ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景颜色：" } }, [
            _c(
              "div",
              { staticClass: "flex-between" },
              [
                _c("el-color-picker", {
                  attrs: { "show-alpha": "" },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.bgColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "bgColor", $$v)
                    },
                    expression: "itemInfo.bgColor",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "80%" },
                  on: { input: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.bgColor,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "bgColor", $$v)
                    },
                    expression: "itemInfo.bgColor",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "外部间距：" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "10px",
                },
              },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.marginType,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "marginType", $$v)
                      },
                      expression: "itemInfo.marginType",
                    },
                  },
                  [_vm._v("统一设置")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-left": "20px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        type: "default",
                        icon: "el-icon-minus",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.decreaseValue("margin")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "80px",
                          margin: "0 10px",
                          "text-align": "center",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { size: "mini", type: "number" },
                          on: { change: _vm.updateItem },
                          model: {
                            value: _vm.itemInfo.margin,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemInfo, "margin", _vm._n($$v))
                            },
                            expression: "itemInfo.margin",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: {
                        type: "default",
                        icon: "el-icon-plus",
                        size: "mini",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.increaseValue("margin")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 2 },
                    on: { change: _vm.updateItem },
                    model: {
                      value: _vm.itemInfo.marginType,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemInfo, "marginType", $$v)
                      },
                      expression: "itemInfo.marginType",
                    },
                  },
                  [_vm._v("分开设置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.itemInfo.marginType === 2
              ? _c("div", { staticClass: "separate-settings" }, [
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("上边距")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("marginTop")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.marginTop,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "marginTop",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.marginTop",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("marginTop")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("右边距")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("marginRight")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.marginRight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "marginRight",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.marginRight",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("marginRight")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("下边距")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("marginBottom")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.marginBottom,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "marginBottom",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.marginBottom",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("marginBottom")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-item" }, [
                    _c("span", [_vm._v("左边距")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-control" },
                      [
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-minus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.decreaseValue("marginLeft")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "60px",
                              margin: "0 5px",
                              "text-align": "center",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "mini", type: "number" },
                              on: { change: _vm.updateItem },
                              model: {
                                value: _vm.itemInfo.marginLeft,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemInfo,
                                    "marginLeft",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "itemInfo.marginLeft",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "default",
                            icon: "el-icon-plus",
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.increaseValue("marginLeft")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }